import type { FaireProductEntity } from "../../entity_types/product";

export const p_rwpfpux8dx: FaireProductEntity = {
  token: "p_rwpfpux8dx",
  type: "product",
  name: "Hotel del Coronado San Diego Canvas Tote Bag \u2013 California Coastal Beach Market Tote",
  brandName: "ArteCart",
  imageUrl:
    "https://cdn.faire.com/fastly/450ed1cdbdbf07a6396d57035b54010d0911c5f614bd75962bf0be1cf017ce4b.jpeg",
  priceDollars: 18,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/e2328f101fb4f39a44d9f63eea2a355a89fb835bcf3122eea11adadc33743dc1.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
